import { patch, post } from "./base";

export const solicitarSubscripcion = async (data) => {
    try {
      const response = await post(
        `/Calendario/subscribirse`,
        data
      );
      return response.data;
    } catch (error) {
      throw new Error("Error solicitando subscripcion : " + error.message);
    }
  };

export const admitirSubscripcion = async (data) => {
    try {
      const response = await post(
        `/Calendario/subscripcion/admitir`,
        data
      );
      return response.data;
    } catch (error) {
      throw new Error("Error admitiendo subscripcion : " + error.message);
    }
  };

export const actualizarEstatusSolicitud = async (data) => {
  try {
    const respuesta = await patch(`/Calendario/solicitud`, data);
    return respuesta.data;
  } catch (error) {
    throw new Error("Error actualizando estatus solicitud  : " + error.message);
  }
};

export const actualizarEstatusSubscripcion = async (data) => {
  try {
    const respuesta = await patch(`/Calendario/subscripcion`, data);
    return respuesta.data;
  } catch (error) {
    throw new Error("Error actualizando estatus solicitud  : " + error.message);
  }
};

export const obtenerCitas = async (data) => {
  try {
    const respuesta = await post(`/Calendario/citas`, JSON.stringify(data) );
    return respuesta.data;
  } catch (error) {
    throw new Error("Error actualizando estatus solicitud  : " + error.message);
  }
}